import { MEDIA_MESSAGES } from '../constants/error-messages';
export function getNetworkMediaError() {
  return new Error(MEDIA_MESSAGES.GENERIC_LOAD_FAILURE);
}